import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/addonicon.svg'
import _imports_1 from '@/assets/icons/warnerror.svg'
import _imports_2 from '@/assets/icons/mailsent.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("h4", {
  class: "modal-title",
  id: "assignaddondtitle"
}, "ASSIGN ADD-ON", -1)
const _hoisted_2 = {
  key: 0,
  class: "modalbody"
}
const _hoisted_3 = { class: "datadiv bottommargin" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "headerfont topmargin" }, " Select available add-on ", -1)
const _hoisted_5 = { class: "overflowdiv topmargin" }
const _hoisted_6 = { class: "prodnamediv" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "cellimage",
  alt: "addiconimg",
  title: "addiconimg"
}, null, -1)
const _hoisted_8 = { style: {"text-align":"start"} }
const _hoisted_9 = {
  class: "font-bold",
  style: {"font-size":"14px","line-height":"19.07px"}
}
const _hoisted_10 = { class: "buttonsdiv" }
const _hoisted_11 = {
  key: 1,
  class: "modalbody"
}
const _hoisted_12 = {
  key: 0,
  style: {"display":"flex"},
  class: "maxitems"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "cellimage",
  style: {"margin-top":"10px"},
  alt: "warnerrorimg",
  title: "warnerrorimg"
}, null, -1)
const _hoisted_14 = {
  key: 0,
  class: "errordiv",
  style: {"padding":"1rem 0"}
}
const _hoisted_15 = { class: "buttonsdiv" }
const _hoisted_16 = {
  key: 0,
  class: "fa fa-refresh fa-spin"
}
const _hoisted_17 = {
  key: 2,
  class: "modalbody"
}
const _hoisted_18 = { class: "innerModal" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  style: {"width":"70px","margin-bottom":"1rem"},
  alt: "mailsentimg",
  title: "mailsentimg"
}, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "labelbld" }, "Notification email sent to: ", -1)
const _hoisted_21 = { class: "usersdiv" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = { class: "buttonsdiv" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_SummaryViewModal = _resolveComponent("SummaryViewModal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_ctx.taskType === 'assignaddon')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                id: "prodtoassigntable",
                data: _ctx.addons,
                border: true,
                style: {"width":"100%"},
                "row-style": _ctx.rowdatastyle,
                "highlight-current-row": "",
                onSelectionChange: _ctx.selectedAddOn,
                "row-class-name": _ctx.tableRowClassName,
                "show-header": false,
                "empty-text": "No assignable add-ons available"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    type: "selection",
                    width: "50"
                  }),
                  _createVNode(_component_el_table_column, { "min-width": "230" }, {
                    default: _withCtx((props) => [
                      _createElementVNode("div", _hoisted_6, [
                        _hoisted_7,
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("h6", _hoisted_9, _toDisplayString(props.row.productName), 1),
                          _createElementVNode("label", null, " Version: " + _toDisplayString(props.row.majorVersionNumber) + "." + _toDisplayString(props.row.minorVersionNumber), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, null, {
                    default: _withCtx((props) => [
                      _createTextVNode(_toDisplayString(props.row.seatsUsed) + "/" + _toDisplayString(props.row.seats), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data", "row-style", "onSelectionChange", "row-class-name"])), [
                [_directive_loading, _ctx.addonLoading]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_el_button, {
              id: "assignprodnext",
              round: "",
              class: "btnstyle ml-4",
              variant: "warning",
              onClick: _ctx.nextHandler,
              disabled: !_ctx.showNext
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Next ")
              ]),
              _: 1
            }, 8, ["onClick", "disabled"]),
            _createVNode(_component_el_button, {
              id: "prodassigncancel",
              round: "",
              variant: "outline-dark",
              onClick: _ctx.cancelInvite,
              class: "cancelbtn"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Cancel")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.taskType === 'summary')
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createVNode(_component_SummaryViewModal, {
            selectedAddon: _ctx.selectedAddons,
            dataof: "addon"
          }, null, 8, ["selectedAddon"]),
          (_ctx.showError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _hoisted_13,
                (_ctx.addUserError !== '')
                  ? (_openBlock(), _createElementBlock("label", _hoisted_14, _toDisplayString(_ctx.addUserError), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_el_button, {
              round: "",
              class: "btnstyle ml-4",
              variant: "warning",
              id: "prodassingconfirm",
              onClick: _ctx.sendInvite,
              disabled: !_ctx.enableControls
            }, {
              default: _withCtx(() => [
                (!_ctx.enableControls)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_16))
                  : _createCommentVNode("", true),
                _createTextVNode(" Confirm ")
              ]),
              _: 1
            }, 8, ["onClick", "disabled"]),
            _createVNode(_component_el_button, {
              round: "",
              class: "btnstyle ml-4",
              variant: "warning",
              id: "backbutton",
              onClick: _ctx.backClickHandler
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Back ")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              id: "prodassigncancel",
              round: "",
              variant: "outline-dark",
              onClick: _ctx.cancelInvite,
              class: "cancelbtn"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Cancel")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.taskType === 'emailSent')
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usersSelected, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  style: {"display":"flex"},
                  class: "btm-1"
                }, [
                  _createElementVNode("p", null, [
                    _createTextVNode(_toDisplayString(item.name) + " " + _toDisplayString(item.userName), 1),
                    _hoisted_22,
                    _createTextVNode(" (" + _toDisplayString(item.email) + " ) ", 1)
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_el_button, {
              id: "prodassigndone",
              round: "",
              class: "btnstyle",
              variant: "warning",
              onClick: _ctx.cancelInvite,
              style: {"float":"right"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Done")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}